import { ItemCondition, TemperatureIssueType } from '../../../../enums';

export interface ITemperatureSubtypeDom {
    issueType: TemperatureIssueType;
    explanation: string;
    conditionOfItem: ItemCondition[];
}
